import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
import { ConfluenceBannerFirstPartyRecommendation } from '@post-office/components--confluence-banner-first-party-recommendation';
import { FormattedMessage, useIntl } from 'react-intl';

import { createRender } from './types';
import { PRODUCT_LOGO_JPD_DARK } from '../../../assets/product-logo-jpd-dark';
import { PRODUCT_LOGO_JPD_LIGHT } from '../../../assets/product-logo-jpd-light';
import { type JSX } from 'react/jsx-runtime';

const jpdLogoByTheme = (colorMode: 'light' | 'dark') => {
	return colorMode === 'light' ? <PRODUCT_LOGO_JPD_LIGHT /> : <PRODUCT_LOGO_JPD_DARK />;
};

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }) => {
		const intl = useIntl();
		const { colorMode } = useThemeObserver();

		return (
			<ConfluenceBannerFirstPartyRecommendation
				app={{
					hamsIdentifier: 'jira-product-discovery',
					ccpProductId: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
					logo: (
						<span
							role="img"
							aria-label={intl.formatMessage({
								id: 'post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text',
								description:
									'Alt text for the product logo in Jira Product Discovery recommendation message in Confluence Home Banner',
								defaultMessage: 'Jira Product Discovery Product Logo',
							})}
						>
							{jpdLogoByTheme(colorMode || 'light')}
						</span>
					),
					header: (
						<FormattedMessage
							id="post-office.growth.recommendation-jpd.confluence-home-banner.header"
							description="Header for Jira Product Discovery recommendation message in Confluence Home Banner"
							defaultMessage="Capture your ideas and customer feedback all in one place"
						/>
					),
					description: (
						<FormattedMessage
							id="post-office.growth.recommendation-jpd.confluence-home-banner.description"
							description="Description for Jira Product Discovery recommendation message in Confluence Home Banner"
							defaultMessage="Make sure your team is building the right things with Jira Product Discovery."
						/>
					),
				}}
				onDismissed={onDismissed}
			/>
		);
	});

export default render;
